module.exports = __webpack_public_path__ + "media/images/game_icon/th/AB1025-89634874c340a870e5f1d2c63b1e1603.png";